// "Band for: All · A · B" — which band the controls around it show and edit
// while the band is split by section or written feel (components/bandScope.ts).
// Shown at the top of the mixer, in the Style panel above the presets, over
// the Tempo panel's kit and beside the Chords menu's Backing, all reading one
// stored scope, so a choice made in one is the choice in all of them.

import { BAND_SCOPE_ALL } from './bandScope';
import type { BandEditor } from './useBandEditor';
import { TransportControlButton } from './TransportBar';

export function BandScopeRow({
  editor,
  playingLabel = null,
  withOneBand = false,
  testid = 'band-scope',
}: {
  editor: BandEditor;
  /** The label the band is playing, marked in the row. */
  playingLabel?: string | null;
  /** The One band button, where no band-changes choice sits beside the row. */
  withOneBand?: boolean;
  testid?: string;
}) {
  const split = editor.split;
  if (!split) return null;
  const options = [BAND_SCOPE_ALL, ...split.labels];
  return (
    <div className="band-scope" data-testid={testid}>
      <span className="band-scope-label">Band for</span>
      <div className="segmented panel-segmented" role="group" aria-label="Band for">
        {options.map((id) => {
          const all = id === BAND_SCOPE_ALL;
          const playing = !all && playingLabel === id;
          return (
            <button
              key={id}
              type="button"
              className={editor.scope === id ? 'active' : ''}
              aria-pressed={editor.scope === id}
              data-testid={`${testid}-${all ? 'all' : id}`}
              data-playing={playing || undefined}
              aria-label={playing ? `${id}, playing` : undefined}
              onClick={() => editor.setScope(id)}
            >
              {all ? 'All' : id}
            </button>
          );
        })}
      </div>
      {withOneBand && (
        <TransportControlButton
          variant="preset"
          className="band-scope-one"
          data-testid={`${testid}-one`}
          onClick={editor.oneBand}
        >
          One band
        </TransportControlButton>
      )}
    </div>
  );
}
